export const calculateRunningAverage = dailySummaries => {
  const daysWithReviews = dailySummaries.filter(day => day.reviewReceiveCount > 0)

  if (!daysWithReviews.length) {
    return { average: 0, reviewCount: 0 }
  }

  const reviewCount = daysWithReviews.reduce((sum, day) => sum + day.reviewReceiveCount, 0)
  const weightedSum = daysWithReviews.reduce(
    (sum, day) => sum + day.averageRating * day.reviewReceiveCount,
    0
  )

  return { average: weightedSum / reviewCount, reviewCount }
}
